const monographs = {
  あ: 'a',
  い: 'i',
  う: 'u',
  え: 'e',
  お: 'o',

  // K
  か: 'ka',
  き: 'ki',
  く: 'ku',
  け: 'ke',
  こ: 'ko',

  // S
  さ: 'sa',
  し: 'shi',
  す: 'su',
  せ: 'se',
  そ: 'so',

  // T
  た: 'ta',
  ち: 'chi',
  つ: 'tsu',
  て: 'te',
  と: 'to',

  // N
  な: 'na',
  に: 'ni',
  ぬ: 'nu',
  ね: 'ne',
  の: 'no',

  // H
  は: 'ha',
  ひ: 'hi',
  ふ: 'fu',
  へ: 'he',
  ほ: 'ho',

  // M
  ま: 'ma',
  み: 'mi',
  む: 'mu',
  め: 'me',
  も: 'mo',

  // Y
  や: 'ya',
  ゆ: 'yu',
  よ: 'yo',

  // R
  ら: 'ra',
  り: 'ri',
  る: 'ru',
  れ: 're',
  ろ: 'ro',

  // W
  わ: 'wa',
  // ゐ: 'wi',
  // ゑ: 'we',
  を: 'wo',

  // Nasal
  ん: 'n',
};

const diacritics = {
  // G
  が: 'ga',
  ぎ: 'gi',
  ぐ: 'gu',
  げ: 'ge',
  ご: 'go',

  // Z
  ざ: 'za',
  じ: 'ji',
  ず: 'zu',
  ぜ: 'ze',
  ぞ: 'zo',

  // D
  だ: 'da',
  ぢ: 'di',
  づ: 'du',
  で: 'de',
  ど: 'do',

  // B
  ば: 'ba',
  び: 'bi',
  ぶ: 'bu',
  べ: 'be',
  ぼ: 'bo',

  // P
  ぱ: 'pa',
  ぴ: 'pi',
  ぷ: 'pu',
  ぺ: 'pe',
  ぽ: 'po',
};

const digraphs = {
  // K
  きゃ: 'kya',
  きゅ: 'kyu',
  きょ: 'kyo',

  // S
  しゃ: 'sha',
  しゅ: 'shu',
  しょ: 'sho',

  // T
  ちゃ: 'cha',
  ちゅ: 'chu',
  ちょ: 'cho',

  // N
  にゃ: 'nya',
  にゅ: 'nyu',
  にょ: 'nyo',

  // H
  ひゃ: 'hya',
  ひゅ: 'hyu',
  ひょ: 'hyo',

  // M
  みゃ: 'mya',
  みゅ: 'myu',
  みょ: 'myo',

  // R
  りゃ: 'rya',
  りゅ: 'ryu',
  りょ: 'ryo',

  // G
  ぎゃ: 'gya',
  ぎゅ: 'gyu',
  ぎょ: 'gyo',

  // J
  じゃ: 'ja',
  じゅ: 'ju',
  じょ: 'jo',

  // D
  ぢゃ: 'dya',
  ぢゅ: 'dyu',
  ぢょ: 'dyo',

  // B
  びゃ: 'bya',
  びゅ: 'byu',
  びょ: 'byo',

  // P
  ぴゃ: 'pya',
  ぴゅ: 'pyu',
  ぴょ: 'pyo',
};

export default { monographs, diacritics, digraphs };
